export default __webpack_public_path__ + "static/media/4b4afb2c1f22aa35a9aaf728f385e3ef1579889629682.1fbefda2.webp";